import { render, staticRenderFns } from "./BannerStatusBadge.vue?vue&type=template&id=eabd2cd6&scoped=true"
import script from "./BannerStatusBadge.vue?vue&type=script&lang=js"
export * from "./BannerStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./BannerStatusBadge.vue?vue&type=style&index=0&id=eabd2cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabd2cd6",
  null
  
)

export default component.exports